export default "__VITE_ASSET__Cesw$gq9__"